import * as Moment from 'moment-timezone';
import * as React from 'react';
import * as Datetime from 'react-datetime';
import { parseDateOnly } from 'src/UtilityFunctions/DateFormat';

export class SuperDateTime extends React.Component {

    public props: any;
    public state = {
        gotDate: false,
        typedDate: Moment(),
    };
    constructor(props: any) {
        super(props);
    }

    private handleOnChange = (value: any) => {
        const typedDate = parseDateOnly(value);
        if (typedDate.isValid()) {
            this.setState({gotDate: true, typedDate});
        }
        this.props.onChange(value);
    }


    public render() {
        return <Datetime 
            value={this.props.value}
            viewDate={this.state.typedDate}
            inputProps={this.props.inputProps}
            onChange={this.handleOnChange}
            onBlur={this.props.onBlur}
        />;
    }
}


// WEBPACK FOOTER //
// ./src/Components/DateComponent/SuperDateTime.tsx